import { createAction } from 'redux-actions';

export const selectReceiver = createAction('GOS_CERTIFICATE_SELECT_RECEIVER');
